import { ORM } from './CouchORM2';

export default class LibraryTags extends ORM {
    static modelName = "LibraryTags";
}